var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 123,
    viewBox: "0 0 120 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb6gxp5cbb",
    x1: 0.141,
    y1: 0.875,
    x2: 1.169,
    y2: -0.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464646"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u8om237rlc",
    x1: 0.141,
    y1: 0.875,
    x2: 1.169,
    y2: -0.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464646"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb9248v7ka",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8940"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "qt4xlsa49e",
    x1: 0,
    x2: 1,
    xlinkHref: "#gb9248v7ka"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "835lcaih0f",
    x1: 0.166,
    y1: 0.175,
    x2: 0.851,
    y2: 0.865,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7ad"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "9z3wkwy59d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38466",
    style: {
      fill: "none"
    },
    d: "M0 0h62.846v79.532H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Launcher icon",
    transform: "translate(-156 -222)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38549",
    width: 120,
    height: 120,
    rx: 32,
    transform: "translate(156 225)",
    style: {
      fill: "url(#vb6gxp5cbb)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38547",
    width: 120,
    height: 120,
    rx: 32,
    transform: "translate(156 222)",
    style: {
      fill: "url(#u8om237rlc)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Launcher icon",
    transform: "translate(177.328 241.991)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40840"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40839",
    style: {
      clipPath: "url(#9z3wkwy59d)"
    },
    transform: "translate(5.308 .009)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13890",
    d: "M59.505 42.439A7.959 7.959 0 0 0 48.544 44.4a18.128 18.128 0 1 1-.8-22.177 7.77 7.77 0 0 0 9.02 2.276 7.87 7.87 0 0 0 3.056-12.3 33.814 33.814 0 1 0-48.391 46.945l19.713 19.39a3.475 3.475 0 0 0 4.851.023l18.865-18.2h-.077a33.777 33.777 0 0 0 6.611-6.938 7.848 7.848 0 0 0-1.886-10.974",
    style: {
      fill: "#ffe500"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13889",
    d: "M47.424-10 11.063-1.649a12.118 12.118 0 0 0-.4 24.1l36.765 8.5a2.524 2.524 0 0 0 2.524-2.524V-7.476A2.524 2.524 0 0 0 47.424-10",
    transform: "translate(27.723 24.162)",
    style: {
      opacity: 0.7,
      fill: "url(#qt4xlsa49e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3648",
    cx: 6.256,
    cy: 6.256,
    r: 6.256,
    transform: "translate(33.276 28.419)",
    style: {
      fill: "url(#835lcaih0f)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3647",
    cx: 6.256,
    cy: 6.256,
    r: 6.256,
    transform: "translate(33.276 28.419)",
    style: {
      fill: "url(#835lcaih0f)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "viewer/static/media/main-logo.d0a382826a9ea6f4bb5e2b3a86c5cd56.svg";
export { ForwardRef as ReactComponent };